<template>
	<div class="description mid-container" v-if="item">
		<div class="section-left">
			<div class="section-characteristics" v-if="item?.field_release_year || approp || item?.field_duration || quality">
				<div class="section-characteristics--column">
					<p class="vl-font-size--14 year" v-if="item?.field_release_year">{{ item?.field_release_year }}</p>
					<p class="vl-font-size--14 age" v-if="approp">{{ approp }}</p>
				</div>
				<div class="section-characteristics--column">
					<p class="vl-font-size--14 duration" v-if="item?.field_duration">{{ item?.field_duration }}</p>
					<p class="vl-font-size--14 quality" v-if="quality">{{ quality }}</p>
					<!--<p class="vl-font-size--14 category" v-if="category">{{ category }}</p>-->
				</div>
			</div>
			<p class="item-description" v-if="item?.field_description" v-html="item?.field_description?.processed"></p>
		</div>

		<div class="section-right" v-if="casting || types || features">
			<p class="vl-font-size--14 casting" v-if="casting">
				<span class="color-red">{{ $t("innerpage.cast") }}:</span> {{ casting }}
			</p>
			<p class="vl-font-size--14 type" v-if="types">
				<span class="color-red">{{ $t("innerpage.type") }}:</span> {{ types }}
			</p>
			<p class="vl-font-size--14 characteristics" v-if="item?.type === 'node--movie' && features">
				<span class="color-red">{{ $t("innerpage.movie_characteristics") }}:</span> {{ features }}
			</p>
			<p class="vl-font-size--14 characteristics" v-if="item?.type === 'node--series' && features">
				<span class="color-red">{{ $t("innerpage.series_characteristics") }}:</span> {{ features }}
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref, Ref, watch } from "vue"
	import { useTaxonomyStore } from "../stores/taxonomies"
	import { Movie } from "../types/Movie"
	import { Series } from "../types/Series"
	const taxonomyStore = useTaxonomyStore()

	const quality: Ref<string | undefined> = ref(undefined)
	const approp: Ref<string | undefined> = ref(undefined)
	const types: Ref<string | undefined> = ref(undefined)
	const category: Ref<string | undefined> = ref(undefined)
	const features: Ref<string | undefined> = ref(undefined)
	const casting: Ref<string | undefined> = ref(undefined)

	const props = defineProps<{
		type: string
		item: Movie | Series
		id: number
	}>()

	watch(
		() => props.item,
		(item) => {
			if (!item) return

			category.value = taxonomyStore.getCategoryTitles(item.field_category)

			if (item.field_appropriateness?.meta?.drupal_internal__target_id) {
				approp.value = taxonomyStore.getAppropriatenessTitle(item.field_appropriateness.meta.drupal_internal__target_id)
			}

			quality.value = taxonomyStore.getQualityTitle(item.field_quality?.meta?.drupal_internal__target_id)
			types.value = taxonomyStore.getTypeTitle(item.field_type)
			features.value = taxonomyStore.getFeaturesTitle(item.field_features)
			casting.value = taxonomyStore.getCastingTitles(item.field_cast)
		},
		{ immediate: true } // run once initially too
	)
</script>

<style lang="scss" scoped>
	.description {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-right: 50px;
		padding-top: 20px;

		@include br.respond-to(br.$tablet-large) {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			padding-right: 0;
			gap: 20px;
		}

		&.align-start {
			align-items: start;
		}

		.section-characteristics {
			display: flex;
			margin: 40px 0;
			gap: 20px;

			@include br.tablet-down {
				margin: 10px 0;
			}

			&--column {
				min-width: 50px;
				&:last-child {
					display: flex;
					flex-wrap: wrap;
					width: 100%;
					column-gap: 20px;
				}
			}
			p {
				margin: 0;
			}
		}
		.section-right {
			max-width: 225px;

			@include br.respond-to(br.$tablet-large) {
				max-width: 100%;
			}
			.type {
				margin-bottom: 25px;

				@include br.respond-to(br.$tablet-large) {
					margin-bottom: 10px;
				}
			}
		}
	}
	.category {
		width: 100%;
	}
	.casting {
		margin-bottom: 25px;

		@include br.respond-to(br.$tablet-large) {
			margin-bottom: 10px;
		}
	}
	.item-description {
		max-width: 415px;
		font-size: 14px;
		line-height: 20px;
		font-weight: 500;

		@include br.respond-to(br.$tablet-xlarge) {
			max-width: 100%;
		}
	}
</style>
